import { Box } from '@mui/material'
import { MRT_Column } from 'material-react-table'
import { ReactElement, useMemo } from 'react'
import ColumnFilterInput from './ColumnFilterInput'

interface CustomTextFilterProps<DataType extends Record<string, any>> {
    column: MRT_Column<DataType>
    templateId: string
    fetchAllOrgsForOrgFilter: boolean
}

const CustomFilters = <DataType extends Record<string, any>>({
    column,
    templateId,
    fetchAllOrgsForOrgFilter,
}: CustomTextFilterProps<DataType>): ReactElement => {
    const filterValue = column.getFilterValue() ?? ''
    const dataType = (column.columnDef as any).dataType
    const range = (column.columnDef as any).range
    const attributeName = (column.columnDef as any).attributeName

    const columnHeaderLabelWidth = useMemo(() => {
        const element = document.getElementById(`column-header-${column.id}`)
        if (element) {
            const labelElement = element.querySelector(
                '.Mui-TableHeadCell-Content-Wrapper',
            )
            const rect = labelElement?.getBoundingClientRect()
            if (rect) {
                if (window.innerWidth - rect?.x <= 300) {
                    return '-230px'
                } else {
                    const leftgap = rect?.width + 20
                    return '-' + leftgap + 'px'
                }
            } else {
                return '-70px'
            }
        } else {
            return '-70px'
        }
    }, [column])

    return (
        <Box
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}
            sx={{
                width: '250px',
                position: 'absolute',
                top: '25px',
                left: columnHeaderLabelWidth,
                background: '#fff',
                borderRadius: '5px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.50)',
            }}
            className="list-custom-column-filter"
        >
            <ColumnFilterInput
                id={
                    (column.columnDef.accessorKey as string) ||
                    column.columnDef.header ||
                    column.id
                }
                header={column.columnDef.header || ''}
                dataType={dataType}
                range={range}
                attributeName={attributeName}
                value={filterValue}
                onChange={(val) => column.setFilterValue(val)}
                templateId={templateId}
                fetchAllOrgsForOrgFilter={fetchAllOrgsForOrgFilter}
            />
        </Box>
    )
}

export default CustomFilters
